import { render, staticRenderFns } from "./cModalMarca.vue?vue&type=template&id=435223d3"
import script from "./cModalMarca.vue?vue&type=script&lang=js"
export * from "./cModalMarca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports